import { setAuthUser } from './reducer';
import { http } from '../../Lib/Http/httpClient';
export function getCurrentUser() {
    return function (dispatch) {
        return http.client.get('/users/getCurrent').then(function (response) {
            dispatch(setAuthUser(response.data.data));
            return response.data.data;
        });
    };
}
